import { render, staticRenderFns } from "./FlavorInfo.vue?vue&type=template&id=4dbba1ab&scoped=true&"
import script from "./FlavorInfo.vue?vue&type=script&lang=js&"
export * from "./FlavorInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlavorInfo.vue?vue&type=style&index=0&id=4dbba1ab&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbba1ab",
  null
  
)

export default component.exports